<div class="mini-graph">
    @if (!hasSelection()) {
        <p class="note">Select a node or connection in the canvas to see what it connects to.</p>
    }@else if (isEmpty()) {
        <p class="note">{{getEmptyMessage()}}</p>
    }
    <div #miniGraphHost class="mini-graph-control" [class.hidden]="!hasSelection()"></div>
</div>
